import { HttpClientModule } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { RtAnalyticsModule } from '@recruitee/analytics';
import { AccountBase, DetachedRouterModule, RtcErrorHandlerModule } from '@recruitee/common';
import { I18nModule, LANGUAGE_CONFIG, LOCALE } from '@recruitee/i18n';
import { RtUIModule, UiProvidersModule } from '@recruitee/user-interface';

import { environment } from '../environments/environment';
import { RtoAppComponent } from './app.component';
import { AppRevisionProvider, AppRevisionToken } from './app.revision';
import { RtoAppRoutingModule } from './onboarding.routing.module';
import { OnboardingSharedModule } from './shared/shared.module';

export const defaultLocale = 'en';

@Injectable()
export class Account extends AccountBase {}

@NgModule({
  declarations: [RtoAppComponent],
  imports: [
    ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
    RtAnalyticsModule.forRoot({
      disable: !environment.analytics,
      segmentKey: environment.analyticsKey,
      trackRouteChange: false,
    }),
    OnboardingSharedModule,
    BrowserModule,
    I18nModule.forPhraseApp({
      phraseAppProjectId: environment.phraseAppProjectId,
      editor: true,
    }),
    RtcErrorHandlerModule.forRoot(
      {
        enable: environment.prodMode,
        dsn: environment.sentry_dsn,
        revisionToken: AppRevisionToken,
      },
      Account,
    ),
    RtUIModule,
    UiProvidersModule.forRoot(),
    RtoAppRoutingModule,
    DetachedRouterModule,
    HttpClientModule,
  ],
  providers: [
    Account,
    AppRevisionProvider,
    { provide: LOCALE, useValue: defaultLocale },
    {
      provide: LANGUAGE_CONFIG,
      useValue: {
        defaultLanguage: 'en',
        languages: ['en', 'nl', 'de', 'fr', 'sv', 'fi'],
      },
    },
  ],
  bootstrap: [RtoAppComponent],
})
export class RtoAppModule {}
